import React, { Component } from 'react';
import styles from './index.module.less';

class Title extends Component {
  render() {
    const title = this.props.titleName;
    const titleStyle = this.props.titleStyle;
    return (
      <div className={styles.title} style={titleStyle}>
        {title}
      </div>
    );
  }
}

export default Title;
